import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://api.job-interview.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 3,
      "name": "gb.svg",
      "url": "https://api.job-interview.sk/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 4,
    "name": "Poľský jazyk",
    "locale": "pl",
    "image": {
      "id": 4,
      "name": "pl.svg",
      "url": "https://api.job-interview.sk/files/pl.svg?ai=0",
      "custom_title": "pl",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 5,
    "name": "Maďarský jazyk",
    "locale": "hu",
    "image": {
      "id": 5,
      "name": "hu.svg",
      "url": "https://api.job-interview.sk/files/hu.svg?ai=0",
      "custom_title": "hu",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 6,
    "name": "Španielský jazyk",
    "locale": "es",
    "image": {
      "id": 6,
      "name": "es.svg",
      "url": "https://api.job-interview.sk/files/es.svg?ai=0",
      "custom_title": "es",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 7,
    "name": "Francúzsky jazyk",
    "locale": "fr",
    "image": {
      "id": 7,
      "name": "fr.svg",
      "url": "https://api.job-interview.sk/files/fr.svg?ai=0",
      "custom_title": "fr",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 9,
    "name": "Talianský jazyk",
    "locale": "it",
    "image": {
      "id": 9,
      "name": "it.svg",
      "url": "https://api.job-interview.sk/files/it.svg?ai=0",
      "custom_title": "it",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 10,
      "name": "de.svg",
      "url": "https://api.job-interview.sk/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 18,
    "name": "Ruský jazyk",
    "locale": "ru",
    "image": {
      "id": 18,
      "name": "ru.svg",
      "url": "https://api.job-interview.sk/files/ru.svg?ai=0",
      "custom_title": "ru",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
